<template>
  <section class="migration-callout">
    <div class="migration-callout__inner">
      <div class="migration-callout__icon">
        <i class="fa-regular fa-rocket" />
      </div>
      <div class="migration-callout__body">
        <div class="migration-callout__eyebrow">
          {{ t('billing.subscriptionPage.migration.eyebrow') }}
        </div>
        <h3 class="migration-callout__title">
          {{ t('billing.subscriptionPage.migration.title') }}
        </h3>
        <p class="migration-callout__text">
          {{ t('billing.subscriptionPage.migration.text') }}
        </p>
      </div>
      <div class="migration-callout__actions">
        <SpmButton
          :label="t('billing.subscriptionPage.migration.cta')"
          icon="fa-regular fa-arrow-right"
          icon-pos="right"
          class-style="p-button migration-callout__cta"
          @click="$emit('migrate')"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'MigrationCallout',

  components: { SpmButton },

  emits: ['migrate'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utilities/variables";

.migration-callout {
  background: linear-gradient(135deg, #fefce8 0%, #ffffff 60%);
  border: 1px solid #fde68a;
  border-radius: 16px;
  overflow: hidden;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: -80px;
    right: -80px;
    width: 240px;
    height: 240px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(250, 183, 16, 0.18) 0%, transparent 70%);
    pointer-events: none;
  }

  &__inner {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 20px;
    padding: 24px 28px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }

  &__icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: $brand-color-primary;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    flex-shrink: 0;
  }

  &__body {
    min-width: 0;
  }

  &__eyebrow {
    font-size: 0.6875rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-weight: 700;
    color: #b45309;
    margin-bottom: 4px;
  }

  &__title {
    font-size: 1.125rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 4px;
  }

  &__text {
    font-size: 0.875rem;
    color: #4b5563;
    margin: 0;
    line-height: 1.5;
  }

  &__actions {
    flex-shrink: 0;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  &__cta {
    background: $brand-color-primary !important;
    border-color: $brand-color-primary !important;
    color: #fff !important;
    font-weight: 600 !important;

    &:hover {
      background: #7aae26 !important;
      border-color: #7aae26 !important;
    }
  }
}
</style>
